import { Routes } from '@angular/router';
import { InformativosPage } from './pages/informativos/informativos.page';
import { AlterarPage } from './pages/alterar/alterar.page';
import { ModalHrpPage } from './pages/modal-hrp/modal-hrp.page';
import { ModalSgaPage } from './pages/modal-sga/modal-sga.page';
import { FaturasPage } from './pages/faturas/faturas.page';
import { ArquivosListPage } from './pages/arquivos-list/arquivos-list.page';
import { Atendimentos24Page } from './pages/atendimentos24/atendimentos24.page';
import { EventosPage } from './pages/eventos/eventos.page';
import { IndicacaoPage } from './pages/indicacao/indicacao.page';
import { EmpresaPage } from './pages/empresa/empresa.page';
import RegisterFuelComponent from './pages/register-fuel/register-fuel.component';

export const routes: Routes = [
  { path: '', redirectTo: 'splash', pathMatch: 'full' },

  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'splash',
    loadComponent: () =>
      import('./pages/splash/splash.page').then((m) => m.SplashPage),
  },
  {
    path: 'principal',
    loadComponent: () =>
      import('./pages/principal/principal.page').then((m) => m.PrincipalPage),
  },
  {
    path: 'esqueci',
    loadComponent: () =>
      import('./pages/esqueci/esqueci.page').then((m) => m.EsqueciPage),
  },
  {
    path: 'clientes',
    loadComponent: () =>
      import('./pages/clientes/clientes.page').then((m) => m.ClientesPage),
  },
  {
    path: 'nova-consulta',
    loadComponent: () =>
      import('./pages/nova-consulta/nova-consulta.page').then(
        (m) => m.NovaConsultaPage,
      ),
  },
  {
    path: 'rate-instalador',
    loadComponent: () =>
      import('./pages/rate-instalador/rate-instalador.page').then(
        (m) => m.RateInstaladorPage,
      ),
  },
  {
    path: 'termos-pre-acesso',
    loadComponent: () =>
      import('./pages/termos-pre-acesso/termos-pre-acesso.page').then(
        (m) => m.TermosPreAcessoPage,
      ),
  },
  {
    path: 'register-fuel',
    component: RegisterFuelComponent,
  },
  {
    path: 'shortcuts',
    loadComponent: () =>
      import('./pages/shortcuts/shortcuts.page').then((m) => m.ShortcutsPage),
  },
  {
    path: 'contratos',
    loadComponent: () =>
      import('./pages/contratos/contratos.page').then((m) => m.ContratosPage),
  },
  { path: 'modal-hrp', component: ModalHrpPage },
  { path: 'modal-sga', component: ModalSgaPage },
  { path: 'faturas', component: FaturasPage },
  {
    path: 'modal-cartao',
    loadComponent: () =>
      import('./pages/modal-cartao/modal-cartao.page').then(
        (m) => m.ModalCartaoPage,
      ),
  },
  {
    path: 'consulta',
    loadComponent: () =>
      import('./pages/consulta/consulta.page').then((m) => m.ConsultaPage),
  },
  {
    path: 'filtro',
    loadComponent: () =>
      import('./pages/filtro/filtro.page').then((m) => m.FiltroPage),
  },
  { path: 'arquivos-list', component: ArquivosListPage },
  {
    path: 'atendimentos',
    loadComponent: () =>
      import('./pages/atendimentos/atendimentos.page').then(
        (m) => m.AtendimentosPage,
      ),
  },
  {
    path: 'atendimentos-chat',
    loadComponent: () =>
      import('./pages/atendimentos-chat/atendimentos-chat.page').then(
        (m) => m.AtendimentosChatPage,
      ),
  },
  {
    path: 'custos',
    loadComponent: () =>
      import('./pages/custos/custos.page').then((m) => m.CustosPage),
  },
  {
    path: 'adicionais',
    loadComponent: () =>
      import('./pages/custos/adicionais/adicionais.page').then(
        (m) => m.AdicionaisPage,
      ),
  },
  { path: 'indicacao', component: IndicacaoPage },
  { path: 'empresa', component: EmpresaPage },
  {
    path: 'shopping',
    loadComponent: () =>
      import('./pages/shopping/shopping.page').then((m) => m.ShoppingPage),
  },
  {
    path: 'product-detail',
    loadComponent: () =>
      import('./pages/product-detail/product-detail.page').then(
        (m) => m.ProductDetailPage,
      ),
  },
  {
    path: 'product-exchange-form',
    loadComponent: () =>
      import('./pages/product-exchange-form/product-exchange-form.page').then(
        (m) => m.ProductExchangeFormPage,
      ),
  },
  {
    path: 'exchange-history',
    loadComponent: () =>
      import('./pages/exchange-history/exchange-history.page').then(
        (m) => m.ExchangeHistoryPage,
      ),
  },
  {
    path: 'saude',
    loadComponent: () =>
      import('./pages/saude/saude.page').then((m) => m.SaudePage),
  },
  {
    path: 'cartao-associado',
    loadComponent: () =>
      import('./pages/cartao-associado/cartao-associado.page').then(
        (m) => m.CartaoAssociadoPage,
      ),
  },
  { path: 'atendimentos24', component: Atendimentos24Page },
  {
    path: 'termos',
    loadComponent: () =>
      import('./pages/termos/termos.page').then((m) => m.TermosPage),
  },
  { path: 'eventos', component: EventosPage },
  { path: 'alterar', component: AlterarPage },
  {
    path: 'parceiros',
    loadComponent: () =>
      import('./pages/parceiros/parceiros.page').then((m) => m.ParceirosPage),
  },
  { path: 'informativos', component: InformativosPage },
  {
    path: 'rotas',
    loadComponent: () =>
      import('./pages/rotas/rotas.page').then((m) => m.RotasPage),
  },
  {
    path: 'dependente-listar',
    loadComponent: () =>
      import('./pages/dependente-listar/dependente-listar.page').then(
        (m) => m.DependenteListarPage,
      ),
  },
  {
    path: 'dependentes',
    loadComponent: () =>
      import('./pages/dependentes/dependentes.page').then(
        (m) => m.DependentesPage,
      ),
  },
  {
    path: 'page404',
    loadComponent: () =>
      import('./pages/page404/page404.page').then((m) => m.Page404Page),
  },
  {
    path: 'view-vehicle-google-maps',
    loadComponent: () =>
      import(
        './pages/view-vehicle-google-maps/view-vehicle-google-maps.page'
      ).then((m) => m.ViewVehicleGoogleMapsPage),
  },
  {
    path: 'view-vehicle-leafletjs',
    loadComponent: () =>
      import('./pages/view-vehicle-leafletjs/view-vehicle-leafletjs.page').then(
        (m) => m.ViewVehicleLeafletjsPage,
      ),
  },
  {
    path: 'all-vehicles-leaflet',
    loadComponent: () =>
      import('./pages/all-vehicles-leaflet/all-vehicles-leaflet.page').then(
        (m) => m.AllVehiclesLeafletPage,
      ),
  },
  {
    path: 'all-vehicles-google-maps',
    loadComponent: () =>
      import(
        './pages/all-vehicles-google-maps/all-vehicles-google-maps.page'
      ).then((m) => m.AllVehiclesGoogleMapsPage),
  },
  {
    path: 'report-leaflet',
    loadComponent: () =>
      import('./pages/report-leaflet/report-leaflet.page').then(
        (m) => m.ReportLeafletPage,
      ),
  },
  {
    path: 'report-google-maps',
    loadComponent: () =>
      import('./pages/report-google-maps/report-google-maps.page').then(
        (m) => m.ReportGoogleMapsPage,
      ),
  },
  {
    path: 'admin-customers',
    loadComponent: () =>
      import('./pages/admin-customers/admin-customers.page').then(
        (m) => m.AdminCustomersPage,
      ),
  },
  {
    path: 'admin-customer-details',
    loadComponent: () =>
      import('./pages/admin-customer-details/admin-customer-details.page').then(
        (m) => m.AdminCustomerDetailsPage,
      ),
  },
  {
    path: 'vehicle-camera',
    loadComponent: () =>
      import('./pages/vehicle-camera/vehicle-camera.page').then(
        (m) => m.VehicleCameraPage,
      ),
  },
  {
    path: 'reports',
    loadComponent: () =>
      import('./pages/reports/reports.page').then((m) => m.ReportsPage),
  },
  {
    path: 'stop-report',
    loadComponent: () =>
      import('./pages/stop-report/stop-report.page').then(
        (m) => m.StopReportPage,
      ),
  },

  { path: '**', redirectTo: 'page404' },
];
